<template>
    <div @show-client-profile="getClientInfo(client)">
        <update-client-form></update-client-form>

        <budget-groups-view></budget-groups-view>

        <ad-accounts-view></ad-accounts-view>

        <ga-views-view></ga-views-view>

        <social-profiles-view></social-profiles-view>

        <call-tracking-platforms-view></call-tracking-platforms-view>

        <assigned-team-members-view></assigned-team-members-view>

        <div class="panel panel-default Client_Profile__Delete" v-show="isAdmin">
            <div class="panel-heading">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>
                        Delete Client
                    </span>
                </div>
            </div>
            <div class="panel-body">
                <button :class="deleteBtnClasses" @click="showDeleteConfirmation">Delete Client</button>
            </div>
        </div>

        <div class="modal fade" id="modal-delete-client" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Delete Client?
                        </h4>
                    </div>
                    <div class="modal-body">
                          Are you 100% sure that you would like to delete this client?
                    </div>
                      <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="deleteClient">Yes, I am 100% sure</button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Nope</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import GaViewsView from './GaViewsView.vue';
import AdAccountsView from './AdAccountsView.vue';
import BudgetGroupsView from './BudgetGroupsView.vue';
import UpdateClientForm from './UpdateClientForm.vue';
import SocialProfilesView from './SocialProfilesView.vue';
import AssignedTeamMembersView from './AssignedTeamMembersView.vue';
import CallTrackingPlatformsView from './CallTrackingPlatformsView.vue';

export default {
    components: {
        GaViewsView,
        AdAccountsView,
        BudgetGroupsView,
        UpdateClientForm,
        SocialProfilesView,
        AssignedTeamMembersView,
        CallTrackingPlatformsView,
    },

    data() {
        return {
            deleteBtnClasses: ['btn','btn-danger']
        }
    },

    computed: {
        ...mapGetters('client',{
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },

    created() {
        Bus.$on('load-client-profile', this.getClientInfo);
    },

    methods: {
        getClientInfo(client) {
            this.$store.dispatch('client/getClientInfo', {
                client: client
            }).then().catch((response) => {
                Bus.$emit('show-error-alert', response.data.message);
            })
        },

        showClientList() {
            history.pushState(null, null, '#/clients');
            this.$store.dispatch('client/showClientListView');
        },

        showDeleteConfirmation() {
            $('#modal-delete-client').modal('show');
        },

        deleteClient() {
            let self = this;
            $('#modal-delete-client').modal('hide');
            this.$store.dispatch('client/deleteClient')
                .then(response => {
                    self.showClientList();
                    Bus.$emit('show-success-alert', response.message);
                })
                .catch(response => {
                    Bus.$emit('show-error-alert', response.data.message);
                });
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/ClientProfile.vue